import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';

export const AlertDialogTrigger = AlertDialogPrimitive.Trigger;
